import React from 'react'

export function ExplanationAnswerForm({ q, answer, onChange }) {
  const parts = Array.isArray(q.payload?.parts) ? q.payload.parts : []
  const ansParts = Array.isArray(answer?.parts) ? answer.parts : []

  return (
    <div style={{ display: 'grid', gap: 10 }}>
      {parts.map((p, idx) => {
        const prev = ansParts[idx] || { text: '' }
        return (
          <div key={idx} style={{ display: 'grid', gap: 6 }}>
            <div style={{ display: 'flex', gap: 10, alignItems: 'baseline' }}>
              <div style={{ minWidth: 28, color: '#111827', fontWeight: 700 }}>{idx + 1}-</div>
              <div style={{ color: '#111827', whiteSpace: 'pre-wrap', lineHeight: 1.6, flex: 1 }}>
                {p?.prompt || '—'}
              </div>
            </div>
            <textarea
              defaultValue={prev.text || ''}
              onMouseDown={e => e.stopPropagation()}
              onBlur={e => {
                const next = [...ansParts]
                next[idx] = { text: e.target.value }
                onChange(q, { parts: next })
              }}
              style={{ padding: '8px 10px', borderRadius: 8, border: '1px solid #e5e7eb', minHeight: 80, resize: 'vertical' }}
            />
          </div>
        )
      })}
    </div>
  )
}
